<template>
  <div class="explain_module">
    <h3>名师讲解·一学就会</h3>
    <!-- 讲解展示 -->
    <VanTabs v-if="hasExplain" type="card">
      <VanTab v-for="(item, key) in explainData" :key="item.id" :title="item.keysObj.value">
        <div v-if="key !== 'video'" class="tab_content">
          <div class="content">
            <!-- sv标签 -->
            <div v-if="!hasRight" class="vip_tag">
              <img
                src="https://img.yzcdn.cn/upload_files/2020/12/07/FmesChEYjxtApMXRBBQfpb0MVOnl.png"
                alt="1"
              />
            </div>
            <!-- 有权限看讲解 -->
            <div v-if="hasRight" style="height: 100%">
              <AudioExplain v-if="key === 'audio'" :path="getOssPath(item.mediaSource)" />
              <ImgExplain v-if="key === 'img'" :path="getOssPath(item.mediaSource)" />
              <TextExplain v-if="key === 'word'" :text="item.mediaSource" />
            </div>

            <!-- 无权限展示 -->
            <div v-else class="noright_content" @click="checkSv">
              <img class="imgBottom" :src="item.keysObj.noRightImg" />
              <img class="iconBottom position_center" :src="item.keysObj.noRightIcon" />
            </div>
          </div>
        </div>
        <div v-else style="margin-top: 15px">
          <VideoExplain
            :check-sv="checkSv"
            :has-right="hasRight"
            :explain-data="explainData.video.reverse()"
          />
        </div>
      </VanTab>
    </VanTabs>
    <!-- 无讲解 -->
    <div v-else class="tab_content no_content">
      <div class="content flex-col flex-al-center flex-jc-center">
        <img src="https://img.yzcdn.cn/upload_files/2020/12/10/FrvGR2i2IQhi8V4ctKnjiv_fhHpv.png" />
        <span>本题暂无讲解</span>
      </div>
      <div class="commentApply flex-row flex-center">
        <div class="applyadd flex-center" :class="{ hasadd: hasReexplain }" @click="applyDeal">
          申请制作讲解
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs, Dialog, Toast } from 'vant'
import VideoExplain from './videoExplain.vue'
import AudioExplain from './audioExplain.vue'
import TextExplain from './textExplain.vue'
import ImgExplain from './imgExplain.vue'
import { tagKeys, noLikeItems } from './data'
import { questionReexplain } from '../../../../../api/explain'
import { mapState } from 'vuex'
export default {
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    VideoExplain,
    AudioExplain,
    TextExplain,
    ImgExplain
  },
  props: {
    hasRight: {
      type: Boolean,
      default: false
    },
    hasReexplain: {
      type: Boolean,
      default: false
    },
    checkSv: Function,
    getReexplainList: Function
  },
  data() {
    return {
      loaded: false,
      noLikeItems,
      tagKeys
    }
  },
  computed: {
    ...mapState('answerExplain', ['allExplains', 'hasEnjoyList']),
    hasExplain() {
      return this.explains.length > 0
    },
    explains() {
      return this.allExplains || []
    },
    explainData() {
      const data = {}
      const keys = this.tagKeys
      keys.forEach((i) => {
        const res = this.explains.filter((item) => item.mediaType.includes(i.key))
        if (res.length > 0) {
          data[i.key] = JSON.parse(JSON.stringify(i.key === 'video' ? res : res[0]))
          data[i.key].keysObj = i
        }
      })

      return data
    }
  },
  mounted() {},
  methods: {
    getOssPath(url) {
      return url ? this.$env.ossUrl(url) : ''
    },
    applyDeal() {
      if (this.hasReexplain) {
        Toast('您已申请制作讲解')
        return
      }
      const { questionId, workbookId, chapterId, pageId } = this.$route.query
      questionReexplain({
        questionId,
        bookId: workbookId,
        chapterId,
        pageId
      }).then((res) => {
        if (res.data.status === 200) {
          window._hmt.push(['_trackEvent', 'funcTracker', 'click', '申请制作_题目讲解_all'])
          this.getReexplainList()
          Dialog.alert({
            title: '提交成功',
            message: '我们正在努力更新视频讲解!!!'
          })
        } else {
          Dialog.alert({
            title: '提交失败',
            message: '请重新尝试'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.explain_module {
  padding: 0 16px;
  h3 {
    margin: 15px 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    color: #333333;
  }
  .van-tabs__nav {
    border: none;
    margin: 0;
    .van-tab {
      padding: 3px 9px;
      color: #999999;
      background: #f9f9f9;
      border-radius: 6px;
      margin-right: 10px;
      box-sizing: border-box;
      border: none;
      flex: 0 1 auto;
      .van-tab__text {
        font-size: 14px;
        line-height: 21px;
      }
    }
    .van-tab--active {
      background-color: #fef4f4 !important;
      border: 0.5px solid #fed8d5;
      color: #ff2638 !important;
    }
  }
  .tab_content {
    margin-top: 15px;
    border: 0.5px solid #f3f6f9;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.04);
    .content {
      position: relative;
      height: 160px;
      .vip_tag {
        position: absolute;
        z-index: 10;
        left: 10px;
        top: 10px;
        img {
          width: 45px;
          height: 16px;
        }
      }
      .noright_content {
        position: relative;
        .imgBottom {
          width: 100%;
          height: 100%;
        }
        .iconBottom {
          width: 40px;
        }
      }
    }
  }
  .no_content {
    .content {
      background: #fbfbfb;
      img {
        width: 228px;
      }
      span {
        font-size: 12px;
        line-height: 17px;
        color: #999999;
      }
    }
    .applyadd {
      width: 146px;
      height: 34px;
      background: #ff2638;
      border-radius: 17px;
      font-size: 14px;
      line-height: 14px;
      color: #ffffff;
    }
    .hasadd {
      background: #f2f4f8;
      border-radius: 17px;
      color: #a6abb7;
    }
  }
  .van-popup--bottom.van-popup--round {
    border-radius: 20px 20px 0 0;
  }
  .commentApply {
    height: 58px;
    font-size: 14px;
    color: #ff2638;
    border-radius: 0px 0px 6px 6px;
  }
}
</style>
